export const UPDATE_COUNT_DOWN_SALE_CONFIG = 'UPDATE_COUNT_DOWN_SALE_CONFIG';

/** @namespace Bodymod/SaleCountdown/Store/SaleCountdown/Action/updateCountDownSaleConfig */
export const updateCountDownSaleConfig = (payload) => ({
    type: UPDATE_COUNT_DOWN_SALE_CONFIG,
    payload
});
